import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';


export function callback(data){
  alert(data);
}

@Injectable()
export class GeoipService {
  location:any={
    country_name:'',
    state:'',
    city:'',
    latitude:0,
    longitude:0,
    ipv4:''
  }

  httpOptions = {
    headers: new HttpHeaders({ 
      'Access-Control-Allow-Origin':'*'
    })
  };

  constructor(private http:HttpClient) { }
  findMe(){
    let rt = this.http.request('GET',"/geoip/json");
    rt.subscribe(
      local=>{
        this.location = local;
      }
    );
    return rt;
  }
  }
